import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function SuppressionListsIcon(props: IconProps) {
  return (
    <Icon width="72" height="73" viewBox="0 0 72 73" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="36" cy="36.8071" r="36" fill="white" />
      <path
        d="M31.5 36.3071C31.5 31.9071 34.1667 28.4738 35.5 27.3071C37.1667 28.8071 40.5 32.8071 40.5 36.8071C40.5 41.8071 36.5 46.8071 36 46.3071C35.5 45.8071 31.5 41.8071 31.5 36.3071Z"
        fill="#57D7FF"
      />
      <circle cx="27.1232" cy="36.9303" r="13.1232" stroke="#191A1C" strokeWidth="1.2" />
      <circle cx="44.8766" cy="36.9303" r="13.1232" stroke="#191A1C" strokeWidth="1.2" />
      <path d="M33.2461 31.5771L40.2461 38.5771" stroke="#191A1C" strokeWidth="1.2" />
      <path d="M31.9951 36.2809L38.9951 43.2809" stroke="#191A1C" strokeWidth="1.2" />
    </Icon>
  );
}
